import React from 'react';
import {
  Button,
  Divider,
  Flex,
  HStack,
  Icon,
  Image,
  Link as ChakraLink,
  Stack,
  Text,
  useBreakpointValue,
  useColorMode,
  useColorModeValue,
} from '@chakra-ui/react';

import { Link } from 'react-router-dom';

import { LuAtSign, LuSun, LuMoon } from 'react-icons/lu';

import { SubmitHandler, useForm } from 'react-hook-form';

import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import { Input } from '../../components/shared/Input';

import logoWhite from '../../assets/SignIn/logo.svg';
import logoBlue from '../../assets/SignIn/logo.png';
import backend from '../../services/backend';

type ForgotFormData = {
  email: string;
};

const forgotFormSchema = yup.object().shape({
  email: yup.string().required('E-mail obrigatório').email('E-mail inválido'),
});

const Forgot: React.FC = () => {
  const { register, handleSubmit, formState } = useForm({
    resolver: yupResolver(forgotFormSchema),
  });

  const { isSubmitting, errors } = formState;

  const isWideVersion = useBreakpointValue({
    base: false,
    sm: true,
    md: true,
    lg: true,
  });

  const { colorMode, toggleColorMode } = useColorMode();

  const bg = useColorModeValue('blue.600', 'gray.800');
  const bgWideVersion = useColorModeValue('white', 'gray.800');
  const bgForm = useColorModeValue('white', 'gray.700');
  const bgFormWideVersion = useColorModeValue('white', 'gray.800');
  const color = useColorModeValue('gray', 'white');
  const colorIcon = useColorModeValue('blue.500', 'white');
  const link = useColorModeValue('blue.600', 'white');

  const handleForgot: SubmitHandler<ForgotFormData> = async data => {
    try {
      const response = await backend.post(`/recuperacao-email/${data.email}`);
    } catch (error) {
      //
    }
  };

  return (
    <Flex
      w="100vw"
      h="100vh"
      flexDir="column"
      align="center"
      justify="center"
      bg={[bgWideVersion, bg]}
    >
      {(isWideVersion || colorMode !== 'light') && (
        <Image src={logoWhite} alt="Okton - Sistemas Empresariais" mb="8" />
      )}

      {colorMode === 'light' && !isWideVersion && (
        <Image
          src={logoBlue}
          alt="Okton - Sistemas Empresariais"
          mb="8"
          w="250px"
        />
      )}

      <Flex
        as="form"
        width="100%"
        maxWidth={488}
        flexDir="column"
        p="8"
        rounded="2xl"
        boxShadow={['none', 'xs']}
        bg={[bgFormWideVersion, bgForm]}
        onSubmit={handleSubmit(handleForgot)}
      >
        <Stack spacing="4">
          <Flex justify="space-between">
            <div />
            <Text
              color={color}
              fontSize="sm"
              fontWeight="medium"
              align="center"
            >
              Não consegue entrar?
            </Text>

            <Icon
              as={colorMode === 'light' ? LuSun : LuMoon}
              color={colorIcon}
              fontSize={[18, 22]}
              onClick={toggleColorMode}
            />
          </Flex>

          <Input
            type="email"
            label="A gente vai mandar um link de recuperação para"
            error={errors.email}
            leftIcon={LuAtSign}
            {...register('email')}
          />
        </Stack>

        <Button type="submit" mt="6" isLoading={isSubmitting}>
          Enviar link de recuperação
        </Button>

        <Divider my="6" borderColor={color} />

        <HStack justify="center">
          <Link to="/">
            <ChakraLink as="div" color={link} fontSize="sm">
              Voltar à página de entrada
            </ChakraLink>
          </Link>
        </HStack>
      </Flex>
    </Flex>
  );
};

export default Forgot;
